// ===== SHARED SIDEBAR TRANSLATIONS =====
// Union of the keys previously duplicated in the four sidebar copies.
export const sidebarTranslations = {
  en: {
    // Navigation
    dashboard: "Dashboard",
    employees: "Employees",
    attendance: "Attendance",
    calendar: "Calendar",
    messages: "Messages",
    reports: "Reports",
    payroll: "Payroll",
    analytics: "Analytics(Locked)",
    settings: "Settings",
    DocumentsManagement: "Documents Management",
    LeaveApprovalPage: "Leave Management",
    AdvancementsManagement: "Solfa Management",
    ChangesPage: "Employee Changes",
    TaxCalculator: "Tax Calculator",
    configuration: "Company Configuration",

    // Notifications
    notifications: "Notifications",
    markAllRead: "Mark All Read",
    noNotifications: "No notifications",

    // Loading & Errors
    loading: "Loading...",
    retry: "Retry",
    failedToLoad: "Failed to load notifications",

    // User Profile
    activeNow: "Active now",
    contact: "Contact",
    noEmail: "No email",
    noPhone: "No phone",

    // Footer
    poweredBy: "Powered by",

    // Buttons
    openSidebar: "Open Sidebar",
    closeSidebar: "Close Sidebar",
    expandSidebar: "Expand Sidebar",
    collapseSidebar: "Collapse Sidebar",
    switchToDark: "Switch to dark mode",
    switchToLight: "Switch to light mode",
    switchEmployee: "Employee View",
    logout: "Logout",

    // Comments
    addComment: "Add Comment",
    writeComment:
      "Write your comment here... (Press Enter to submit, Shift+Enter for new line)",
    sendComment: "Send Comment",
    cancel: "Cancel",
    previousComments: "Previous Comments:",

    // Leave Modal
    reviewLeaveRequest: "Review Leave Request",
    approve: "Approve",
    reject: "Reject",

    // Upload
    uploadProfilePicture: "Upload profile picture",
    uploading: "Uploading...",
    notice: "Notice",
    featureNotAvailable:
      "This feature is not available for your organization.",

    // Logout modal
    confirmLogout: "Confirm Logout",
  },
  ar: {
    // Navigation
    dashboard: "لوحة التحكم",
    employees: "الموظفين",
    attendance: "الحضور",
    calendar: "التقويم",
    messages: "الرسائل",
    reports: "التقارير",
    payroll: "الرواتب",
    analytics: "التحليلات (مقفلة)",
    settings: "الإعدادات",
    DocumentsManagement: "إدارة المستندات",
    LeaveApprovalPage: "إدارة الإجازات",
    AdvancementsManagement: "إدارة السلف",
    ChangesPage: "تغييرات الموظفين",
    TaxCalculator: "حاسبة الضرائب",
    configuration: "إعدادات الشركة",

    // Notifications
    notifications: "الإشعارات",
    markAllRead: "تحديد الكل كمقروء",
    noNotifications: "لا توجد إشعارات",
    leaveRequest: "طلب إجازة",
    calendarEvent: "حدث في التقويم",
    justNow: "الآن",
    minuteAgo: "منذ دقيقة",
    minutesAgo: "منذ {count} دقائق",
    hourAgo: "منذ ساعة",
    hoursAgo: "منذ {count} ساعات",
    dayAgo: "منذ يوم",
    daysAgo: "منذ {count} أيام",

    // Loading & Errors
    loading: "جاري التحميل...",
    retry: "إعادة المحاولة",
    failedToLoad: "فشل تحميل الإشعارات",

    // User Profile
    activeNow: "نشط الآن",
    contact: "التواصل",
    noEmail: "لا يوجد بريد إلكتروني",
    noPhone: "لا يوجد رقم هاتف",

    // Footer
    poweredBy: "مدعوم من",

    // Buttons
    openSidebar: "فتح القائمة",
    closeSidebar: "إغلاق القائمة",
    expandSidebar: "توسيع القائمة",
    collapseSidebar: "طي القائمة",
    switchToDark: "الوضع الداكن",
    switchToLight: "الوضع الفاتح",
    switchEmployee: "عرض الموظف",
    logout: "تسجيل الخروج",

    // Comments
    addComment: "إضافة تعليق",
    writeComment:
      "اكتب تعليقك هنا... (اضغط Enter للإرسال، Shift+Enter لسطر جديد)",
    sendComment: "إرسال التعليق",
    cancel: "إلغاء",
    previousComments: "التعليقات السابقة:",

    // Leave Modal
    reviewLeaveRequest: "مراجعة طلب الإجازة",
    approve: "موافقة",
    reject: "رفض",

    // Upload
    uploadProfilePicture: "تحميل صورة الملف الشخصي",
    uploading: "جاري التحميل...",
    notice: "تنبيه",
    featureNotAvailable: "هذه الميزة غير متاحة لمؤسستك.",

    // Logout modal
    confirmLogout: "تسجيل الخروج",
  },
};

export default sidebarTranslations;
